import { useCallback, useEffect } from "react";

import { ClassSessionCategory } from "components/server-types";
import { storeApi, useAppSelector } from "store/index";
import { selectActiveClassSession, selectAvActiveClassUsersIds } from "store/selectors";
import {
  selectCalculatedListForActiveParticipants,
  selectIsParticipantBarLeader,
} from "store/selectors/virtual-class-users-sorting";

export const useParticipantBarObserver = () => {
  const isLeaderOfParticipantBar = useAppSelector(selectIsParticipantBarLeader);
  const activeClassSession = useAppSelector(selectActiveClassSession);
  const participantBarList = useAppSelector(selectAvActiveClassUsersIds);
  const calculatedList = useAppSelector(selectCalculatedListForActiveParticipants);

  const updateParticipantBarList = useCallback(
    (newParticipantBarList: string[]) => {
      if (!activeClassSession) return;
      storeApi.class_sessions.partial_update({
        id: activeClassSession.id,
        av_active_class_users_ids: newParticipantBarList,
      });
    },
    [activeClassSession],
  );

  useEffect(() => {
    if (
      !isLeaderOfParticipantBar ||
      !activeClassSession ||
      activeClassSession.category !== ClassSessionCategory.VIRTUAL
    )
      return;
    // If the result of the calculation is the same as the current participant bar list, do nothing.
    if (
      participantBarList.length === calculatedList.length &&
      participantBarList.every((id, index) => id === calculatedList[index])
    )
      return;
    updateParticipantBarList(calculatedList);
  }, [
    isLeaderOfParticipantBar,
    calculatedList,
    activeClassSession,
    participantBarList,
    updateParticipantBarList,
  ]);
};
